import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SiteLayout from "@/components/site/SiteLayout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import CoursePage from "@/pages/CoursePage";
import PracticeTrackPage from "@/pages/PracticeTrackPage";
import ProBonoPage from "@/pages/ProBonoPage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/course" element={<CoursePage />} />
            <Route path="/foundation-track" element={<CoursePage />} />
            <Route path="/practice-track" element={<PracticeTrackPage />} />
            <Route path="/pro-bono" element={<ProBonoPage />} />
            <Route path="/therapists" element={<ProBonoPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
